import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-prevent-loss-panier',
  templateUrl: './prevent-loss-panier.component.html',
  styleUrls: ['./prevent-loss-panier.component.css']
})

export class PreventLossPanierComponent implements OnInit {

  from: any = null;
  innerHeight: number = window.innerHeight;

  constructor(
    public dialogRef: MatDialogRef<PreventLossPanierComponent>,
    @Inject(MAT_DIALOG_DATA) data:any
  ) {
    if (data) {
      this.from = data;
    }
  }

  ngOnInit() { }

  close(where?: string) {
    this.dialogRef.close(where);
  }

}
